// components/About.tsx
import React from "react";
import aboutImg from "../../assets/aboutImg.jpg";
import tailoredTasteGraphic from "../../assets/attt.png";

export default function About() {
  return (
    <section
      className="relative bg-white overflow-hidden"
      // data-aos="fade-up"
      // data-aos-offset="150"
    >
      <div className="max-w-[1920px] mx-auto pt-20 pb-12">
        {/* Headline */}
        <div
          className="mb-16 lg:mb-20 text-center lg:text-left max-w-7xl mx-auto px-6 lg:px-8 xl:px-12"
          data-aos="fade-down"
        >
          <p
            className="text-xs md:text-sm tracking-widest text-[#4E5C36] uppercase mb-4"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            What is A Tailored Taste?
          </p>
          <h2
            className="text-3xl md:text-4xl w-full md:w-[60%] mx-auto lg:mx-0 font-extrabold text-[#111827] leading-tight favela"
            data-aos="fade-right"
            data-aos-delay="300"
          >
            Where craft meets culture, and dinner becomes a conversation.
          </h2>
          {/* <p
            className="mt-6 max-w-xl text-gray-500 mx-auto lg:mx-0"
            data-aos="fade-left"
            data-aos-delay="400"
          >
            Discover your personal style and the confidence that comes with it.
          </p> */}
        </div>

        {/* Main content */}
        <div className="relative">
          {/* Green background */}
          <div
            className="absolute inset-0 bg-[#4E5C36] h-full md:h-[520px] lg:h-[580px] mt-8 md:mt-0"
            data-aos="fade-in"
            data-aos-delay="200"
          />

          <div className="relative z-10 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              {/* LEFT: Image */}

              <div className="relative -mt-8 md:mt-0 md:-translate-y-6 lg:-translate-y-12">
                <div className="w-full bg-white rounded-sm shadow-2xl overflow-hidden">
                  <img
                    src={aboutImg}
                    alt="Tailored Taste attendees"
                    className="w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[680px] object-cover"
                  />
                </div>

                {/* Brown accents (now visible on all screens) */}
                <div className="absolute -right-3 sm:-right-4 md:-right-6 -bottom-3 sm:-bottom-4 w-3 sm:w-4 md:w-6 h-20 sm:h-28 md:h-60 bg-[#95822C] z-20" />
                <div className="absolute -bottom-3 sm:-bottom-4 -right-3 sm:-right-4 md:-right-6 w-[50%] sm:w-[60%] md:w-[70%] h-3 sm:h-4 md:h-6 bg-[#95822C] z-10" />
              </div>

              {/* RIGHT: Content */}
              <div
                className="relative"
                data-aos="fade-left"
                data-aos-delay="400"
              >
                <div className="bg-[#4E5C36] text-white h-full min-h-[360px] md:min-h-[520px] lg:min-h-[580px] flex flex-col justify-center items-center text-center md:text-left px-6 md:px-10 lg:px-12 py-10 lg:py-16">
                  <div
                    className="max-w-md mx-auto md:mx-0"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    {/* Main Description */}
                    <p className="text-sm md:text-base lg:text-lg leading-6 md:leading-7 mb-6 text-white/95">
                      <span className="font-semibold">A Tailored Taste</span> is
                      a flagship black-tie{" "}
                      <span className="font-semibold">private dining</span>{" "}
                      evening by Marquess London with Chef Tandoh: an intimate,
                      chef-led{" "}
                      <span className="font-semibold">five-course</span> service
                      built for real conversation. It expresses the ML house
                      DNA:{" "}
                      <span className="font-semibold">
                        West African roots, British sensibility, European
                        finesse,
                      </span>{" "}
                      in a measured, modern setting. Seats are limited; the pace
                      is considered.
                    </p>

                    {/* Pre-CTA Insight */}
                    <p className="text-sm md:text-base italic text-white/90 mb-8">
                      Calm room, considered pace. Arrive as yourself; we’ll
                      handle the details.
                    </p>

                    {/* CTA Button */}
                    <button
                      onClick={() => {
                        document
                          .getElementById("tickets")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }}
                      className="inline-block cursor-pointer text-sm md:text-base border border-white px-6 md:px-8 py-3 md:py-4 rounded-sm hover:bg-white/95 hover:text-[#4E5C36] transition-all duration-150 font-medium"
                      data-aos="zoom-in"
                      data-aos-delay="600"
                    >
                      Secure your seat
                    </button>
                  </div>

                  {/* Tailored Taste graphic */}
                  <div
                    className="mt-10 lg:mt-auto lg:absolute lg:right-8 lg:bottom-8"
                    data-aos="fade-up"
                    data-aos-delay="700"
                  >
                    <img
                      src={tailoredTasteGraphic}
                      alt="A Tailored Taste"
                      className="w-28 sm:w-32 lg:w-36 opacity-95 mx-auto md:mx-0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
